// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HudAppointmentCard-module__row___zMs8_ {
  display: grid;
  grid-template-columns: 96px minmax(0, 1fr);
  align-items: stretch;
  gap: 8px;
}

.HudAppointmentCard-module__card___dQeEL {
  font-family: inherit;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 16px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.HudAppointmentCard-module__card___dQeEL:hover {
  border-color: #a1a1aa;
}
.HudAppointmentCard-module__card___dQeEL:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: 2px;
}

.HudAppointmentCard-module__cardSelected___qeYs1 {
  border-color: #18181b;
  background: #fafafa;
  box-shadow: 0 0 0 1px #18181b;
}
.HudAppointmentCard-module__cardSelected___qeYs1:hover {
  border-color: #18181b;
}

.HudAppointmentCard-module__nameLine___qb94_ {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 8px;
}

.HudAppointmentCard-module__name___IJ__2 {
  font-size: 17px;
  line-height: 1.5556;
  font-weight: 600;
  color: #18181b;
}

.HudAppointmentCard-module__age___MX6gk {
  font-size: 14px;
  line-height: 1.5;
  color: #71717a;
}

.HudAppointmentCard-module__visitLine___wVBQs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 8px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  color: #18181b;
}

.HudAppointmentCard-module__dot___glaI9 {
  width: 9px;
  height: 9px;
  flex-shrink: 0;
  border-radius: 999px;
}

.HudAppointmentCard-module__seen___by3j0 {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.5;
}

.HudAppointmentCard-module__seenIcon___HhjJ_ {
  flex-shrink: 0;
  margin-top: 2px;
}

.HudAppointmentCard-module__toneSeen___bcc3I {
  color: #52525b;
}

.HudAppointmentCard-module__toneNew___vEuCq {
  font-weight: 500;
  color: #0369a1;
}

.HudAppointmentCard-module__toneNone___hTlCx {
  color: #a1a1aa;
}

.HudAppointmentCard-module__condensedTime___bcRd2 {
  display: flex;
  padding: 0 8px;
  align-self: center;
}

.HudAppointmentCard-module__condensedCard___Z0ATj {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  padding: 6px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.HudAppointmentCard-module__condensedCard___Z0ATj:hover {
  border-color: #a1a1aa;
}
.HudAppointmentCard-module__condensedCard___Z0ATj:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: 2px;
}

.HudAppointmentCard-module__condensedName___FvUOx {
  flex: 0 0 auto;
  white-space: nowrap;
  font-weight: 500;
  color: #3f3f46;
}

.HudAppointmentCard-module__condensedType___fwqFk {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #71717a;
}

.HudAppointmentCard-module__status___wcuce {
  flex-shrink: 0;
  margin-left: auto;
  padding: 1px 8px;
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: #52525b;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/HudAppointmentCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0CAAA;EACA,oBAAA;EACA,QAAA;AACF;;AAEA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AACF;AACE;EACE,qBAAA;AACJ;AAEE;EACE,0BAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,qBAAA;EACA,mBAAA;EACA,6BAAA;AADF;AAGE;EACE,qBAAA;AADJ;;AAKA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AAFF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;AAFF;AAIE;EACE,qBAAA;AAFJ;AAKE;EACE,0BAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAJF;;AAOA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAJF","sourcesContent":[".row {\n  display: grid;\n  grid-template-columns: 96px minmax(0, 1fr);\n  align-items: stretch;\n  gap: 8px;\n}\n\n.card {\n  font-family: inherit;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  padding: 16px;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  background: #ffffff;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n\n  &:hover {\n    border-color: #a1a1aa;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #a1a1aa;\n    outline-offset: 2px;\n  }\n}\n\n.cardSelected {\n  border-color: #18181b;\n  background: #fafafa;\n  box-shadow: 0 0 0 1px #18181b;\n\n  &:hover {\n    border-color: #18181b;\n  }\n}\n\n.nameLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 4px 8px;\n}\n\n.name {\n  font-size: 17px;\n  line-height: 1.5556;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.age {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #71717a;\n}\n\n.visitLine {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0 8px;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #18181b;\n}\n\n.dot {\n  width: 9px;\n  height: 9px;\n  flex-shrink: 0;\n  border-radius: 999px;\n}\n\n.seen {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin-top: 8px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.seenIcon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.toneSeen {\n  color: #52525b;\n}\n\n.toneNew {\n  font-weight: 500;\n  color: #0369a1;\n}\n\n.toneNone {\n  color: #a1a1aa;\n}\n\n.condensedTime {\n  display: flex;\n  padding: 0 8px;\n  align-self: center;\n}\n\n.condensedCard {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  padding: 6px 12px;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.5;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n\n  &:hover {\n    border-color: #a1a1aa;\n  }\n\n  &:focus-visible {\n    outline: 2px solid #a1a1aa;\n    outline-offset: 2px;\n  }\n}\n\n.condensedName {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  font-weight: 500;\n  color: #3f3f46;\n}\n\n.condensedType {\n  flex: 1 1 0;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #71717a;\n}\n\n.status {\n  flex-shrink: 0;\n  margin-left: auto;\n  padding: 1px 8px;\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: #52525b;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `HudAppointmentCard-module__row___zMs8_`,
	"card": `HudAppointmentCard-module__card___dQeEL`,
	"cardSelected": `HudAppointmentCard-module__cardSelected___qeYs1`,
	"nameLine": `HudAppointmentCard-module__nameLine___qb94_`,
	"name": `HudAppointmentCard-module__name___IJ__2`,
	"age": `HudAppointmentCard-module__age___MX6gk`,
	"visitLine": `HudAppointmentCard-module__visitLine___wVBQs`,
	"dot": `HudAppointmentCard-module__dot___glaI9`,
	"seen": `HudAppointmentCard-module__seen___by3j0`,
	"seenIcon": `HudAppointmentCard-module__seenIcon___HhjJ_`,
	"toneSeen": `HudAppointmentCard-module__toneSeen___bcc3I`,
	"toneNew": `HudAppointmentCard-module__toneNew___vEuCq`,
	"toneNone": `HudAppointmentCard-module__toneNone___hTlCx`,
	"condensedTime": `HudAppointmentCard-module__condensedTime___bcRd2`,
	"condensedCard": `HudAppointmentCard-module__condensedCard___Z0ATj`,
	"condensedName": `HudAppointmentCard-module__condensedName___FvUOx`,
	"condensedType": `HudAppointmentCard-module__condensedType___fwqFk`,
	"status": `HudAppointmentCard-module__status___wcuce`
};
module.exports = ___CSS_LOADER_EXPORT___;
